import styled from 'styled-components'

export const LocationWidget = styled.div`
  position: absolute;
  width: 100%;
  top: -80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 768px) {
    top: -63.7px;
  }
  @media (max-width: 600px) {
    top: -50px;
  }
  .locationButton {
    background: none; 
    border: none;
    :focus {
      outline: none
    }
  }
  .locationSvg {
    cursor: pointer;
    width: 80px;
    height: 80px;
    @media (max-width: 768px) {
      width: 46.2px;
      height: 63.7px;
    }
    @media (max-width: 600px) {
      width: 36px;
      height: 50px;
    }
  }
  .locationLogo {
    margin-top: 23px;
    object-fit: cover;
    width: 131px;
    height: 131px;
    border-radius: 6px;
    box-shadow: 0 10px 5px 0 rgba(147, 147, 147, 0.1);
    @media (max-width: 768px) {
      width: 92px;
      height: 92px;
      margin-top: 17px;
    }
    @media (max-width: 600px) {
      width: 65.5px;
      height: 65.7px;
      margin-top: 7px;
    }
    z-index: 1;
  }
  .address {
    text-align: center;
    margin-top: -40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 370px;
    min-height: 250px;
    @media (max-width: 768px) {
      width: 259px;
      min-height: 175px;
    }
    @media (max-width: 600px) {
      width: 206px;
      min-height: 125px;
      margin-top: -23px;
    }
    border-radius: 10px;
    box-shadow: 0 1px 6px 1px rgba(186, 186, 186, 0.2);
    border: solid 1px #ffffff;
    background-color: #ffffff;
    //span {
    //  width: 256px;
    //}
  }
  span {
    font-size: 20px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: 2px;
    :first-child {
      margin-bottom: 30px;
      margin-top: 35px;
    }
    @media (max-width: 768px) {
      font-size: 14px;
      line-height: 1.57;
      letter-spacing: normal;
    }
    @media (max-width: 600px) {
      :first-child {
        margin-bottom: 10px;
      }
      :last-child {
        margin-bottom: 10px;
      }
    }
  }
`
